const URL_REGEX =
	// eslint-disable-next-line security/detect-unsafe-regex
	/^https?:\/\/(?:localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}|(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)*[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)(?::\d+)?(?:\/[^\s]*)?$/;

export const isValidUrl = (value: any) => URL_REGEX.test(value);
